<template>
  <header id="header" class="site-header">
    <div class="container">
      <div class="header-inner">
        <router-link class="brand" to="/">
          <span class="brand-mark"></span>
          <span class="brand-copy">
            <strong class="brand-name">北海带恩</strong>
            <small class="brand-sub">会员权益解决方案</small>
          </span>
        </router-link>

        <nav class="desktop-nav">
          <router-link
            v-for="item in navList"
            :key="item.path"
            :to="item.path"
            class="nav-link"
            :class="{ active: $route.path === item.path }"
          >
            {{ item.name }}
          </router-link>
        </nav>

        <button class="mobile-toggle" type="button" @click="menuOpen = !menuOpen" aria-label="切换导航">
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>

      <transition name="fade">
        <div v-if="menuOpen" class="mobile-panel">
          <div class="mobile-panel-inner">
            <router-link
              v-for="item in navList"
              :key="item.path"
              :to="item.path"
              class="mobile-link"
              :class="{ active: $route.path === item.path }"
              @click.native="menuOpen = false"
            >
              {{ item.name }}
            </router-link>
          </div>
        </div>
      </transition>
    </div>
  </header>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      menuOpen: false,
      navList: [
        { name: "首页", path: "/" },
        { name: "产品中心", path: "/software" },
        { name: "相关服务", path: "/service" },
        { name: "案例中心", path: "/casecenter" },
        { name: "咨询中心", path: "/newsinformation" },
        { name: "关于我们", path: "/companyintroduction" },
        { name: "联系我们", path: "/contactus" }
      ]
    };
  },
  watch: {
    $route() {
      this.menuOpen = false;
    }
  }
};
</script>

<style scoped>
.site-header {
  position: sticky;
  top: 0;
  z-index: 999;
  padding: 14px 0 0;
  transition: all 0.25s ease;
}

.site-header.header-fixed {
  padding-top: 10px;
}

.site-header.header-fixed .header-inner {
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 18px 46px rgba(21, 31, 46, 0.14);
}

.header-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding: 14px 18px;
  border-radius: 26px;
  background: rgba(255, 255, 255, 0.66);
  border: 1px solid rgba(23, 33, 43, 0.08);
  box-shadow: 0 14px 36px rgba(21, 31, 46, 0.08);
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
}

.brand {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  text-decoration: none;
}

.brand-mark {
  position: relative;
  width: 40px;
  height: 40px;
  border-radius: 14px;
  background: linear-gradient(135deg, #ff7a59 0%, #10b8a6 100%);
  box-shadow: 0 10px 26px rgba(255, 122, 89, 0.3);
}

.brand-mark::before,
.brand-mark::after {
  content: "";
  position: absolute;
  inset: 10px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.16);
}

.brand-mark::after {
  inset: 14px;
  background: rgba(255, 255, 255, 0.28);
}

.brand-copy {
  display: flex;
  flex-direction: column;
}

.brand-name {
  font-size: 18px;
  line-height: 1.1;
  font-weight: 800;
}

.brand-sub {
  margin-top: 4px;
  color: var(--muted);
  font-size: 12px;
}

.desktop-nav {
  display: flex;
  align-items: center;
  gap: 8px;
}

.nav-link {
  display: inline-flex;
  align-items: center;
  min-height: 42px;
  padding: 0 14px;
  border-radius: 999px;
  color: var(--muted);
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
  transition: background 0.2s ease, color 0.2s ease, transform 0.2s ease;
}

.nav-link:hover,
.nav-link.active {
  color: var(--text);
  background: rgba(255, 122, 89, 0.12);
}

.mobile-toggle {
  display: none;
  width: 46px;
  height: 46px;
  padding: 0;
  border: 1px solid rgba(23, 33, 43, 0.1);
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.88);
}

.mobile-toggle span {
  display: block;
  width: 18px;
  height: 2px;
  margin: 3px auto;
  border-radius: 999px;
  background: var(--text);
}

.mobile-panel {
  margin-top: 12px;
}

.mobile-panel-inner {
  padding: 14px;
  border-radius: 22px;
  background: rgba(255, 255, 255, 0.86);
  border: 1px solid rgba(23, 33, 43, 0.08);
  box-shadow: 0 12px 36px rgba(21, 31, 46, 0.08);
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
}

.mobile-link {
  display: block;
  padding: 14px 4px;
  border-bottom: 1px solid rgba(23, 33, 43, 0.08);
  font-size: 15px;
  font-weight: 600;
  text-decoration: none;
}

.mobile-link:last-child {
  border-bottom: 0;
}

.mobile-link.active {
  color: var(--accent);
}

@media screen and (max-width: 991px) {
  .desktop-nav {
    gap: 4px;
  }

  .nav-link {
    padding: 0 11px;
  }
}

@media screen and (max-width: 767px) {
  .header-inner {
    padding: 12px 14px;
    border-radius: 22px;
  }

  .desktop-nav {
    display: none;
  }

  .mobile-toggle {
    display: inline-grid;
    place-items: center;
  }

  .brand-name {
    font-size: 16px;
  }

  .brand-sub {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue